<template>
	<b-modal
		ref="modal"
		id="confirm-dialog"
		:modal-class="theme"
		hide-header
		hide-footer
		centered
		body-class="modal__terms"
		size="lg"
	>
		<Terms :inModal="true"/>
		<div class="modal__controls">
			<button class="btn btn-primary" @click="hide">Close</button>
		</div>
	</b-modal>
</template>

<script>
import Terms from "../../components/terms/Terms";
import ThemeService from "../../services/theme";

export default {
	name: "TermsDialog",
	components: {
		Terms,
	},
	data: function () {
		return {
			error: null,
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		show: function () {
			this.$refs["modal"].show();
		},
		hide: function () {
			this.$refs["modal"].hide();
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style scoped>
.modal__controls {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
.modal-body {
	padding: 3rem !important;
}
</style>